import { render, staticRenderFns } from "./PwaNotification.vue?vue&type=template&id=16a4a377&scoped=true&"
import script from "./PwaNotification.vue?vue&type=script&lang=js&"
export * from "./PwaNotification.vue?vue&type=script&lang=js&"
import style0 from "./PwaNotification.vue?vue&type=style&index=0&id=16a4a377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a4a377",
  null
  
)

export default component.exports